module.exports = __webpack_public_path__ + "img/play.56424531.svg";